<template>
  <DefaultLayout class="overflow-hidden">
    <v-navigation-drawer
      v-model="drawer"
      v-bind="bindDrawer"
      app
      class="sidebar_auth"
      :mini-variant="isMini"
      width="320"
      v-if="siderbarItem.length > 0"
    >
      <siderbar :mini="isMini" :items="siderbarItem"></siderbar>
    </v-navigation-drawer>
    <navbar
      class="header_auth"
      clipped-left
      :drawer.sync="currentDrawer"
      :hide-header-aside="!siderbarItem.length"
    ></navbar>
    <v-main class="d-flex">
      <loading-container location="layout">
        <router-view />
        <slot />
      </loading-container>
    </v-main>
    <TheFooter />
  </DefaultLayout>
</template>

<script>
import { getVersion } from '../constant'
import navbar from './navbar.vue'
import TheFooter from './footer.vue'
import siderbar from './siderbar.vue'
import DefaultLayout from './default-layout.vue'
import { siderbarItem } from '@constant'
import { mapGetters } from 'vuex'
import { isFunction } from 'axios/lib/utils'
export default {
  components: { navbar, siderbar, TheFooter, DefaultLayout },
  data: () => ({
    drawer: false,
    isShowSidebar: true,
    siderbarItem: [],
  }),
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
    isMini() {
      return !this.isMobile && !this.drawer
    },
    bindDrawer() {
      if (this.isMobile) {
        return {
          temporary: true,
          bottom: true,
        }
      }
      return {
        permanent: true,
        clipped: true,
      }
    },
    version() {
      return getVersion()
    },
    currentDrawer: {
      get() {
        return this.drawer
      },
      set(value) {
        this.drawer = value
      },
    },
  },
  mounted() {},
  watch: {
    currentUser: {
      handler() {
        if (!this.currentUser || !isFunction(this.currentUser.hasPermission)) {
          this.siderbarItem = []
          return
        }
        this.siderbarItem = siderbarItem.filter((x) => {
          if (!x.scopes) return true
          return this.currentUser.hasPermissions(x.scopes)
        })
      },
      immediate: true,
    },
  },
  methods: {
    onToggleShowSidebar(e) {
      this.isShowSidebar = e
      this.drawer = e
    },
  },
}
</script>
<style lang="scss" scoped>
.header_auth {
  background: #ffffff !important;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 8%) !important;
}
.sidebar_auth {
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.25);
}
</style>
